<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" :breadList="breadList"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" :breadList="breadList"></router-view>
  </div>
</template>

<script>

export default {
  name: "App",
  data() {
    return {
      breadList: [],
    };
  },
  mounted() {
    function setScale() {
      const dpr = window.devicePixelRatio || 1;
      const scale = 1 / dpr;

      const viewportMeta = document.querySelector('meta[name="viewport"]');
      viewportMeta.content = `width=device-width, initial-scale=${scale}, maximum-scale=${scale}, minimum-scale=${scale}, user-scalable=no`;

      // 设置根字体大小（可选）
      document.documentElement.style.fontSize = `${16 * dpr}px`;
    }

    // 初始化执行
    setScale();
    // 监听屏幕旋转等变化
    window.addEventListener('resize', setScale);
  },
  methods: {
  }
};
</script>

<style lang="less">
@import url("./assets/style/public.less");
</style>
